/** Created by azhou on 2019/2/14.*/
<template>
  <div>
    <public-title>
      <!-- <div class="listType">{{listType}}</div> -->
      <span class="text-danger h6" v-show="!showLists">（*项必传）</span>
      <ul v-show="showLists" class="room_type" v-if="listType==='房型'">
      <template v-for="item in roomType">
        <li
          v-if="item.name == '全  部' || StoreRoomArr.info[item.value] > 0"
          :key="item.value"
          :class="{ center: item.type == currentType }"
          @click="queryCon.type = item.type; queryCon.page = 1; getLists(); currentType = item.type"
        >
          {{ item.name }}
          <span v-if="item.name !== '全  部'">({{ StoreRoomArr.info[item.value] }})</span>
        </li>
      </template>
      </ul>
      <div slot="right" class="ml-auto">
        <el-button 
          @click="$router.back()" 
          type="primary" 
          size="small" 
          v-if="orderId"
          >
          返回报价订单
        </el-button>
        <el-button 
          @click="addRoomMeet" 
          class="btn-login" 
          size="small"
          >{{showLists?('添加'+listType):'返回列表'}}
        </el-button>
      </div>
    </public-title>
    <!--展示房间、会议室列表-->
    <p v-if="showLists&& ListArr.total<=0">当前没有数据</p>
    <ul class="list-head" v-if="showLists && ListArr.total>0">
      <li :class="['名称', '房型图片', '操作', '会议室布局'].includes(item) ? 'w-50' : 'w-25'" v-for="item in titleArr" :key="item">
        {{item}}
        <span v-show="item === '排序'" class="prompt">(从大到小)</span>
        <i class="el-icon-edit text-link ml-2" v-show="item === '排序'" @click="changeSort"></i>
      </li>
    </ul>
    <div v-if="showLists && listType==='房型'">
      <room-itemize 
        v-for="(item,index) in StoreRoomArr.meetArr" 
        :Itemize="item" 
        :key="item.id"
        :index="index"
        :showSortInput="showSortInput"           
        @editItem="editItem(index)"
        @clone="clone(index)" 
        @deleteItem="deleteItem(index)" 
        @uploadPic="uploadPic"/>
    </div>
    <div v-if="showLists && listType==='会议室'">
      <meet-itemize 
        v-for="(item,index) in StoreMeetArr.meetArr" 
        :Itemize="item" :key="item.id"
        :showSortInput="showSortInput"           
        @editItem="editItem(index)" @clone="clone(index)" @deleteItem="deleteItem(index)" 
        @uploadPic="uploadPic"
      />
    </div>
    <el-pagination background layout="prev, pager, next" class="mt-4" v-if="showLists&& ListArr.total>0"
                    :total="ListArr.total" :current-page="Number(queryCon.page)"
                    @current-change="v => {this.queryCon.page=v;this.getLists()}"/>
    <!--展示添加、编辑房间页面-->
    <add-edit-room 
      class="add-wide m-auto" 
      v-if="!showLists && listType==='房型'" 
      @successFun="addEditRoomSuccess" 
      :roomEdit="roomEdit" 
      :editObj="editObj" 
      :add="roomEdit"/>
    <!--展示添加、编辑会议室页面-->
    <add-edit-meet 
      class="add-wide m-auto" 
      v-if="!showLists && listType==='会议室'" 
      @successFun="addEditMeetSuccess" 
      :roomEdit="roomEdit" 
      :editObj="editObj"/>
    <!--修改图片-->
    <el-dialog 
      :title="'修改'+listType+'图片'" 
      :visible.sync="modifyTheImage" width="600px" center id="loadConfirm" top="22vh">
        <div class="">
          当前房型：{{formData.title}}
          <span v-if="formData.assist">（{{formData.assist}}）</span>
        </div>
        <upload-image 
        @fileChange="(imgs)=>formData.pic = imgs" 
        :existImgs="formData.pic" 
        :modifyTheImage="true" 
        :maxLength="10"/>
        <div class="theImage-bottom">
            <el-button  @click="modifyTheImage=false" >取消退出</el-button>
            <el-button  @click="submitForm"  type="primary">保存更新</el-button>
        </div>    
    </el-dialog>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import AddEditRoom from './AddEditRoom'
  import AddEditMeet from './AddEditMeet'
  import RoomItemize from './RoomItemize'
  import MeetItemize from './MeetItemize'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  export default {
    name: 'StoreRoomMeetLists',
    computed: {
      ...mapState(['StoreRoomArr', 'StoreMeetArr','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      orderId () { return this.$route.query.orderId},
      storeId() { return this.$route.query.storeId },
      //判断是否是销售用户注册门店添加房型
      step() { return this.$route.query.step},
      listType () {
        switch (this.type || this.$route.query.step*1) {
          case 3:return '房型';
          case 4:return '会议室';
          default:return ''
        }
      },
      ListArr () {
        switch (this.listType) {
          case '房型': return this.StoreRoomArr
          case '会议室': return this.StoreMeetArr
          default: return {}
        }
      },
      titleArr () {
        switch (this.listType) {
          case '房型': return ['排序','名称','房型图片', '房间类型','房间窗户', '房间总数(间)','房间面积(平方米)','操作'];
          case '会议室': return ['排序','名称','房型图片','会议室布局', '层高','面积','操作'];
          default: return [];
        }
      },
    },
    data () {
      return {
        showLists: true,           //是否展示房间/会议室列表
        modifyTheImage:false,      //修改图片弹框
        editObj: {},               //当前编辑的房间、会议室列表
        queryCon:{
          page: 1,
          type:'',
        },
        formData:{
          feature:'',
        },
        roomType:[
          {name:'全  部',value:'',type:'0'}, 
          {name:'单床房',value:'type_1_count',type:'1'},
          {name:'双床房',value:'type_2_count',type:'2'},
          {name:'三床房',value:'type_3_count',type:'3'},
          {name:'多床房',value:'type_4_count',type:'4'}
        ],
        currentType:'0',
        roomEdit:false,             //是否编辑房型，会议室添加
        showSortInput:false,        //是否显示排序输入框
      }
    },
    props: {
      type: {
        type: Number,
        default: 0
      }
    },
    watch:{
      //'listType':'getLists'
      listType () {
        this.queryCon.page = 1;
        this.getLists()
        this.showLists = true
        this.editObj = {}
      }
    },
    
    created() {this.getLists();},
    components: { AddEditMeet, AddEditRoom,RoomItemize,MeetItemize },
    methods: {
      ...mapActions(['getRoomLists', 'getMeetLists', 'deleteRoomMeet','HotelsRoomList','HotelsMeetLists','saveRoom','saveMeet','modifyTheOrder']),
      getLists() {
        if (this.storeId) { this.queryCon.store_id = this.storeId};
        //为注册门店用户
        if(this.step&&this.userLoginMessage.submit_store_id){
          this.queryCon.store_id = this.userLoginMessage.submit_store_id;
        }
        if (this.listType === '房型') this.HotelsRoomList(this.queryCon);
        if (this.listType === '会议室') this.HotelsMeetLists(this.queryCon);
      },
      addRoomMeet () {
        // if (this.showLists && !this.$GFUN.powerIsInArray([183,188,307,302,557])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (this.showLists) this.editObj = {}
        this.showLists = !this.showLists
      },
      /**打开上传图片弹框*/
      uploadPic (e) {
        this.formData={...this.formData,...e};
        //判断类型添加id字段
          //判断房型类型
        let saveType='';
        if(this.step){saveType=this.step;}else{saveType=this.type;}
        this.formData[`${saveType==3?'room_id':'meeting_id'}`]=e.id;
        delete this.formData.id;
        this.modifyTheImage = true;
      },
      /**提交保存图片**/
      submitForm(){
        let {formData}=this;
        console.log(formData);
        if (this.formData.pic.length <= 0) {
          this._alert(`请至少上传一张${this.listType}图片`,null,'error');
          return
        }
        this._confirm('确认提交么？',async () => {
            //上传图片
            this.modifyTheImage = false;
            formData.pic = await UploadImages(formData.pic);
            //判断房型类型
            let saveType='';
            if(this.step){
              saveType=this.step;
            }else{saveType=this.type;}
            
            let POST=saveType==3?this.saveRoom:this.saveMeet;
            if(saveType==4){
              formData.layout=formData.layout.length>0?JSON.stringify(formData.layout):'';
            }
            //销售创建门店房型添加
            if(this.step){
              formData.store_id = this.userLoginMessage.submit_store_id;
            }
            POST({
              data: formData,
              successFun: () => {
                this.getLists();
              }
            })
        })
      },
      /*保存、编辑房间成功*/
      addEditRoomSuccess () {
        this.showLists = true;
        this.getLists()
      },
      /*保存、编辑会议室成功*/
      addEditMeetSuccess () {
        this.showLists = true;
        this.getLists()
      },
      /*编辑某一条房间会议室*/
      editItem (index) {
        this.editObj = this.ListArr.meetArr[index];
        this.roomEdit=false;
        this.showLists = false;
      },
      /*克隆某一条房间会议室*/
      clone (index) {
        this.editObj = this.ListArr.meetArr[index];
        this.roomEdit=true;
        this.showLists = false;
      },
      /*删除某一条房间会议室*/
      deleteItem (index) {
        // if (!this.$GFUN.powerIsInArray([186,191,305,310,565,559])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确定删除么？', () => {
          let data = {}
          let deleteRoomMeet = this.ListArr.meetArr[index]
          switch (this.storeInfo.type) {
            case 3:
            case 8:
              this.listType === '房型' ? data.room_id = deleteRoomMeet.id : data.meeting_id = deleteRoomMeet.id
              break
            case 5:
              this.listType === '房型' ? data.homestay_room_id = deleteRoomMeet.id : data.homestay_meeting_id = deleteRoomMeet.id
              break
            default:
              break
          }
          this.deleteRoomMeet({
            type: this.listType,
            data,
            successFun: () => this.getLists()
          })
        })
      },
      /*点击排序打开或关闭*/
      changeSort () {
        //关闭后上传信息
        if (this.showSortInput) {
          this.modifyTheOrder({
            type: this.listType,
            data:{sort:this.StoreRoomArr.meetArr.map(v => {
                return {
                  id:v.id,
                  sort:v.sort
                }
              })
            }
          })
        } 
        this.showSortInput = !this.showSortInput;
        this.getLists();
      },
    }
  }
</script>
<style  scoped>
  .w25{
    width: 25% !important;
  }
  .add-wide{
    width: 900px;
  }
  .theImage-bottom{
    margin-top: 20px;
    border-top: 1px #eee solid;
    padding-top: 20px;
    text-align: right;
  }
  .room_type{
    display: flex;
    font-weight: normal;
    font-size: 14px;
  }
  .room_type{
    margin-left: -0.5rem;
  }
  .room_type li{
    color: #333;
    border: 1px #eee solid;
    box-shadow: 0px 6px 6px #eee;
    padding: 6px 20px;
    border-radius: 20px;
    margin-right: 10px;
    cursor: pointer;
    font-size: 12px;
  }
  .room_type li:hover{
    box-shadow: 0px 6px 6px #b1f4ff;
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
  .room_type .center{
    box-shadow: 0px 6px 6px #b1f4ff;
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
  .listType{
    float: left;
  }
  .prompt{
    font-size: 12px;
    color: #999;
    font-weight: normal;
  }
</style>